import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Verify your identity',
    id: 'VerificationTemplate.title',
  },
  subtitle: {
    defaultMessage: 'To continue, first verify it’s you.',
    id: 'VerificationTemplate.subtitle',
  },
});
